import "core-js/modules/es.object.to-string.js";
import { addOrderNote } from '@/services/order/orderList';
import { getOrderDetailBasicInfos, getOrderAddress, getOrderServerNote, updateOrderNote } from '@/services/order/orderDetail';
import { updateCustomerblock } from '@/services/customer/customerList.js';
import { parseTime } from '@/utils/';
export default {
  name: 'orderDetailInfo',
  i18n: require('../i18n-orderDetail'),
  props: {
    orderInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      orderId: "",
      //基础信息
      BasicInfo: {},
      //打印纳品书
      orderNoteList: [],
      //客服备注
      serverNoteList: [],
      isTableLoading: false,
      //打印纳品书
      orderAddress: {},
      //客服备注
      serverNoteVisible: false,
      serverNoteModalValue: {
        note: ""
      },
      serverNoteRules: {
        note: [{
          required: true,
          message: this.$t("orderDetailInfo.noOrderNote"),
          trigger: 'change'
        }]
      },
      //客服备注
      orderNoteVisible: false,
      orderNoteModalValue: {
        note: ""
      },
      orderNoteRules: {
        // orderNote:[{ required: true, message:this.$t("orderDetailInfo.noOrderNote"), trigger: 'change' }]
      }
    };
  },
  computed: {
    noteColumns: function noteColumns() {
      var columns = [{
        //客服备注
        title: this.$t('orderDetailInfo.note'),
        dataIndex: 'note',
        key: 'note'
      }, {
        //新建时间
        title: this.$t('orderDetailInfo.createDate'),
        dataIndex: 'createDate',
        key: 'createDate',
        width: '150px'
      }, {
        //订单状态
        title: this.$t('orderDetailInfo.userName'),
        dataIndex: 'userName',
        key: 'userName',
        width: '100px'
      }];
      return columns;
    },
    orderNoteColumns: function orderNoteColumns() {
      var columns = [{
        //订单编号
        title: this.$t('orderDetailInfo.orderNo'),
        dataIndex: 'orderNo',
        key: 'orderNo',
        width: '100px'
      }, {
        //发货渠道
        title: this.$t('orderDetailInfo.channelTitle'),
        dataIndex: 'channelTitle',
        key: 'channelTitle',
        width: '200px'
      }, {
        //备注内容
        title: this.$t('orderDetailInfo.orderNote'),
        dataIndex: 'orderNote',
        key: 'orderNote'
      }, {
        //备注链接
        title: this.$t('orderDetailInfo.url'),
        dataIndex: 'url',
        key: 'url'
      }, {
        //操作
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '100px'
      }];
      return columns;
    }
  },
  mounted: function mounted() {
    this.isTableLoading = true;
    this.orderId = this.$route.query.id;
    this.loadBasicInfo();
    // this.loadOrderAddress()
    // this.loadServerNoteList()
  },
  methods: {
    parseTime: parseTime,
    loadBasicInfo: function loadBasicInfo() {
      var _this = this;
      getOrderDetailBasicInfos(this.orderId).then(function (response) {
        if (response.data.code == 200) {
          _this.BasicInfo = response.data.data;
          // this.orderInfo.BasicInfo = response.data.data.getInfosMainVo;
          // this.orderNoteList = response.data.data.getInfosChildVoList;
          // this.orderInfo.orderNoteList = response.data.data.getInfosChildVoList;
        }
      }).finally(function () {
        _this.isTableLoading = false;
      });
    },
    // loadOrderAddress(){
    // 	getOrderAddress(this.orderId).then(response => {
    // 				if (response.data.code == 200) {
    // 					this.orderAddress = response.data.data;
    // 				}
    // 			})
    // },
    // loadServerNoteList() {
    // 	this.isTableLoading = true
    // 	getOrderServerNote({ id: this.orderId }).then(response => {
    // 	if ( response.data.code == 200 ) {
    // 		this.serverNoteList = response.data.data;
    // 	}
    // 	}).finally(() => {
    // 	this.isTableLoading = false
    // 	})
    // },
    //客服备注
    serverNoteHandle: function serverNoteHandle() {
      var _this2 = this;
      this.$refs.serverNoteRuleForm.validate(function (valid) {
        if (valid) {
          _this2.serverNoteModalValue.noList = _this2.BasicInfo.orderNo;
          addOrderNote(_this2.serverNoteModalValue).then(function (response) {
            if (response.data.code == 200) {
              _this2.$message.success(_this2.$t('public.updateSuccessfully'));
              _this2.serverNoteVisible = false;
              _this2.loadServerNoteList();
              _this2.serverNoteModalValue = {};
            }
          });
        }
      });
    },
    //修改打印备注
    orderNoteOpen: function orderNoteOpen(record) {
      this.orderNoteModalValue.idList = this.orderId;
      this.orderNoteModalValue.pictrueUrl = record.url;
      this.orderNoteModalValue.orderNote = record.orderNote;
      this.orderNoteVisible = true;
    },
    orderNoteHandle: function orderNoteHandle() {
      var _this3 = this;
      this.$refs.orderNoteRuleForm.validate(function (valid) {
        if (valid) {
          var param = {
            idList: [_this3.orderId],
            langDataList: [{
              langId: _this3.BasicInfo.langId,
              orderNote: _this3.orderNoteModalValue.orderNote
            }],
            pictrueUrl: _this3.orderNoteModalValue.pictrueUrl
          };
          updateOrderNote(param).then(function (response) {
            if (response.data.code == 200) {
              _this3.$message.success(_this3.$t('public.updateSuccessfully'));
              _this3.orderNoteVisible = false;
              _this3.loadBasicInfo();
              _this3.orderNoteModalValue = {};
            }
          });
        }
      });
    },
    //黑名单
    userBlackHandle: function userBlackHandle() {
      var _this4 = this;
      if (!this.BasicInfo.customerBlack) {
        updateCustomerblock({
          orderId: this.orderId,
          customerId: this.BasicInfo.customerId,
          blacklistType: 1,
          relieverPhone: this.orderAddress.userPhone,
          loginIp: this.BasicInfo.userIp
        }).then(function (response) {
          if (response.data.code == 200) {
            _this4.$message.success(_this4.$t('public.updateSuccessfully'));
            _this4.orderNoteVisible = false;
            _this4.loadBasicInfo();
          }
        });
      }
    }
  }
};